import { css } from '@emotion/css';
import { BusinessHoursEntry } from 'Shared/common/BusinessHoursEntry';
import { pageTheme, sizes, theme } from 'Shared/frontend/ThemeProvider';
import { For } from 'solid-js'

const businessHoursStyle = () => css({
	width: '100%',
	marginBottom: '1em',

	[`@media (min-width: ${sizes().desktopWidth}px)`]: {
		textAlign: 'left'
	},

	[`@media (min-width: ${sizes().flipToMobileNav}px)`]: { 
		width: '50%',
		float: 'right'
	}
});

const headingStyle = () => css(pageTheme().section.heading, {
	marginTop: 0,

	[`@media (min-width: ${sizes().desktopWidth}px)`]: {
		/* Trim the empty space from the text so the top aligns with the venue photo */
		marginTop: -12
	}
});

const listStyle = () => css(theme().list,{
	h5: {
		...pageTheme().section.heading, 
		fontSize: '1em',
		margin: '2em 0 1em 0',
		color: 'inherit',
		fontWeight: 700,
		textTransform: 'none'
	}
});


export function BusinessHours(props)
{
	return (
		<div class={businessHoursStyle()}>
			<h3 class={headingStyle()}>Business Hours</h3>

			<ul class={listStyle()}>
				<For each={props.venue.operatingHours}>{ j =>
					<li>
						<BusinessHoursEntry {...j} />
					</li>
				}</For>
			</ul>
		</div>
	);
}

